@if (codes?.products?.length) {
  <sd-component-wrapper
    [content]="wrapperContent"
    [themesConfig]="lameConfig?.backgroundTheme"
    [brand]="brand"
  >
    <wc-base-cross-sell sd-component-wrapper-component
      [codes]="codes"
      [refreshPrices]="false"
      [titleLevel]="2"
      [dynamicContentShowMore]="dynamicContentShowMore"
      (nextPage)="onNext()"
      [isUnderlined]="lameConfig?.titleUnderlined"
      [context]="context"
      [productCodeForAccessory]="productCodeForAccessory"
      [brandCorner]="brand"
    />
  </sd-component-wrapper>
}
